/**
 * Display labels for proto enum values used by the table registries. The numbers mirror
 * `proto/helm/v1/common.proto`; they are repeated here (as `trading/state.ts` does for order
 * states) so the registries run under `node --test` without the generated runtime code.
 */

export const SIDE = { BUY: 1, SELL: 2 } as const;

export const SIDE_LABEL: Readonly<Record<number, string>> = { 1: "Buy", 2: "Sell" };

export const ORDER_TYPE_LABEL: Readonly<Record<number, string>> = {
  1: "Market",
  2: "Limit",
  3: "Stop",
  4: "Stop Limit",
  5: "Trailing Stop",
  6: "MIT",
};

export const ORDER_STATE_LABEL: Readonly<Record<number, string>> = {
  1: "Draft",
  2: "Pending",
  3: "Working",
  4: "Partial",
  5: "Filled",
  6: "Cancelling",
  7: "Cancelled",
  8: "Modifying",
  9: "Rejected",
  10: "Triggered",
  11: "Unknown — reconciling",
  12: "Not placed",
};

/** `BracketRole` (1 entry, 2 target, 3 stop) and `Origin.BRACKET` (10). */
export const BRACKET_ROLE = { ENTRY: 1, TARGET: 2, STOP: 3 } as const;
export const ORIGIN_BRACKET = 10;

export const TIF_LABEL: Readonly<Record<number, string>> = { 1: "Day", 2: "GTC", 3: "IOC", 4: "FOK" };

export const RISK_STATUS_LABEL: Readonly<Record<number, string>> = {
  1: "OK",
  2: "Warn",
  3: "Danger",
  4: "Breached",
  5: "Locked",
  6: "Firm breached",
};
